/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Attachment
 */
export interface Attachment {
    /**
     * 
     * @type {number}
     * @memberof Attachment
     */
    readonly id?: number;
    /**
     * 
     * @type {Date}
     * @memberof Attachment
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Attachment
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    type?: AttachmentTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof Attachment
     */
    owner?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Attachment
     */
    deal?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Attachment
     */
    document?: number | null;
}

export function AttachmentFromJSON(json: any): Attachment {
    return AttachmentFromJSONTyped(json, false);
}

export function AttachmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Attachment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'type': !exists(json, 'type') ? undefined : json['type'],
        'owner': !exists(json, 'owner') ? undefined : json['owner'],
        'deal': !exists(json, 'deal') ? undefined : json['deal'],
        'document': !exists(json, 'document') ? undefined : json['document'],
    };
}

export function AttachmentToJSON(value?: Attachment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'owner': value.owner,
        'deal': value.deal,
        'document': value.document,
    };
}

/**
* @export
* @enum {string}
*/
export enum AttachmentTypeEnum {
    Unknown = 'unknown',
    PassportFront = 'passport_front',
    PassportReverse = 'passport_reverse',
    Inn = 'inn',
    Snils = 'snils',
    Converted = 'converted',
    BirthCertificate = 'birth_certificate',
    ChildRepresentativeApproval = 'child_representative_approval',
    MarriageContract = 'marriage_contract',
    SpousesNotarialConsent = 'spouses_notarial_consent',
    PassportOriginal = 'passport_original',
    Apostille = 'apostille',
    MaternalCapitalCertificate = 'maternal_capital_certificate',
    MaternalCapitalCertificateBalance = 'maternal_capital_certificate_balance',
    MortgageCertificate = 'mortgage_certificate',
    SubsidyCertificate = 'subsidy_certificate'
}


